import axiosInstance from "../mainService";
const sdgsService = {
    getSdgs(search, page,limit,company){
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m148_sdgs/name/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllSdgs(company){
        const sanitizedSearch = 'all';
        return axiosInstance.get(`/count-data/m148_sdgs/name/${sanitizedSearch}/${company}`);
    },
    addSdgs(data){
        return axiosInstance.post('/upload-data-sdgs',data);
    },
    updateSdgs(data){
        return axiosInstance.put(`/update-data/m148_sdgs/${data.id}`,data);
    },
    deleteSdgs(id, sdgs){
        return axiosInstance.delete(`/delete-sdgs/${id}/${sdgs}`);
    }
}

export default sdgsService;